module.exports = __webpack_public_path__ + "img/bpo.de125e95.svg";